import {
	ppdfConsentDownloadQuery,
	useAxiosInstance,
	useDownloadPoMutation,
} from '@gov-nx/api';
import { useDownloadEvents, useMessageEvents } from '@gov-nx/core/events';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';

export const DownloadPpdfConsentListener = () => {
	const { toastMessageSuccess, toastMessageError } = useMessageEvents();
	const { t } = useLocale(LocalizeNameSpaceTypes.Service);
	const { axiosInstance } = useAxiosInstance();

	const { mutate } = useDownloadPoMutation(ppdfConsentDownloadQuery, {
		onSuccess: (props) =>
			download({
				id: props.variables.id,
				...props,
				callback: (id, success, error) => {
					if (success) {
						toastMessageSuccess(
							t('dokument.stazeni-dokumentu-uspech', {
								fileName: props.fileName,
							})
						);
					}
					if (error) {
						toastMessageError();
					}
				},
			}),
	});

	const { download } = useDownloadEvents({
		onPpdfConsentDownload: (_, payload) =>
			mutate(
				{ id: payload.consentId, axiosInstance },
				{
					onSuccess: () =>
						payload.callback && payload.callback(payload.consentId, null, null),
					onError: () =>
						payload.callback && payload.callback(payload.consentId, null, null),
				}
			),
	});

	return null;
};
